import { render, staticRenderFns } from "./Block1.vue?vue&type=template&id=5f18a6d8&scoped=true"
import script from "./Block1.vue?vue&type=script&lang=js"
export * from "./Block1.vue?vue&type=script&lang=js"
import style0 from "./Block1.vue?vue&type=style&index=0&id=5f18a6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f18a6d8",
  null
  
)

export default component.exports